export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Bodega',
	plural_model_name_spanish: 'Bodegas',
	create_model_name_spanish: 'Nueva Bodega',
	text_delete: 'la',
}